import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { FaqContainer, FaqItem } from 'components/shared/faq-item';
import FormContact from 'components/form-contact';
import MainHeader, {
  HeaderText,
  Underline,
} from 'components/shared/landing/main-header';
import { IconList, IconListItem } from 'components/shared/landing/icon-list';
import Modal from 'components/shared/modal';
import styles from './styles.module.scss';

class OnlinePlatform extends Component {
  constructor(props) {
    super(props);

    this.state = { quoteModalOpen: false };

    this.onOpenModalClick = this.onOpenModalClick.bind(this);
    this.onCloseModalClick = this.onCloseModalClick.bind(this);
  }

  onOpenModalClick() {
    this.setState({ quoteModalOpen: true });
  }

  onCloseModalClick() {
    this.setState({ quoteModalOpen: false });
  }

  render() {
    const { quoteModalOpen } = this.state;
    return (
      <div className={styles.onlinePlatform}>
        <MainHeader
          header={
            <HeaderText className={styles.valueProp}>
              Become a Partner <Underline>School or District</Underline>
            </HeaderText>
          }
          subtext="Seamless and fully supported onboarding for your school or district both in-person and online."
          style={styles.onlinePlatformHeader}
        >
          <div className={styles.ctaBox}>
            <div className={styles.subtext}>As low as</div>
            <div className={styles.price}>$7.98*</div>
            <div className={styles.perUser}>Per user/year</div>
            <button onClick={this.onOpenModalClick} className={styles.cta}>
              Get a Quote
            </button>
            <p className={styles.pricingDisclaimer}>
              <small>*lower pricing with more than 1000 learners</small>
            </p>
          </div>
        </MainHeader>
        <section className={styles.moreInfo}>
          <div className="container">
            <div className="row">
              <div className="h-auto mb-5 mb-lg-0 col-lg-4 col-12">
                <div className={styles.benefits}>
                  <h2>Teachers get</h2>
                  <IconList>
                    <IconListItem icon="check" iconClassName="text-apple">
                      Classrooms they organize into teams and small groups
                    </IconListItem>
                    <IconListItem icon="check" iconClassName="text-apple">
                      Real-time reports on student assignments
                    </IconListItem>
                    <IconListItem icon="check" iconClassName="text-apple">
                      Access our Activity Library and create your own lessons!
                    </IconListItem>
                  </IconList>
                </div>
              </div>
              <div className="h-auto mb-5 mb-lg-0 col-lg-4 col-12">
                <div className={styles.benefits}>
                  <h2>Students get</h2>
                  <IconList>
                    <IconListItem icon="check" iconClassName="text-apple">
                      A way to learn faster and better
                    </IconListItem>
                    <IconListItem icon="check" iconClassName="text-apple">
                      Personalized real world SEL skills
                    </IconListItem>
                    <IconListItem icon="check" iconClassName="text-apple">
                      Fun, engaging games to use for learning
                    </IconListItem>
                  </IconList>
                </div>
              </div>
              <div className="h-auto mb-5 mb-lg-0 col-lg-4 col-12">
                <div className={styles.benefits}>
                  <h2>Admins get</h2>
                  <IconList>
                    <IconListItem icon="check" iconClassName="text-apple">
                      Easy-to-use user management system for all roles
                    </IconListItem>
                    <IconListItem icon="check" iconClassName="text-apple">
                      Visibility reports into use and effectiveness by teachers
                    </IconListItem>
                    <IconListItem icon="check" iconClassName="text-apple">
                      Formative SEL assessment progress reports
                    </IconListItem>
                  </IconList>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <div className={styles.learnMore}>
                  <h3>Learn more about the Unyted Platform</h3>
                  <div>
                    <Link to="/educators" className={styles.secondaryCta}>
                      Show Me Platform Details
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {quoteModalOpen && (
          <Modal
            heading="Request a quote for your school or district"
            onClose={this.onCloseModalClick}
            size="lg"
            noFooter
            centered
          >
            <FormContact messageLabel="School, Grade Level, Subject Matter, and # of Students" />
          </Modal>
        )}

        <section className={styles.faqs}>
          <div className="container">
            <div className="row">
              <div className="col-12">
                <h2>Frequently Asked Questions</h2>
              </div>
              <div className="col-12">
                <FaqContainer>
                  <FaqItem question="Where can I find more information about Unyted's platform features?">
                    <p>
                      Many of the comprehensive features and a classroom
                      (in-person) view are available on the{' '}
                      <Link target="_blank" to="/educators">
                        Educators page. You can also contact us for a FREE
                        demonstration.
                      </Link>
                    </p>
                  </FaqItem>

                  <FaqItem
                    question={
                      'What roles in a school and types of educators use Unyted?'
                    }
                  >
                    <p>
                      {' '}
                      The school platform was designed for educators who teach
                      core subjects like Math, Science, ELA, etc., so they can
                      achieve multiple goals and personalize learning. However,
                      Unyted has also been used by school counselors and other
                      roles who support learner' personal skills development.
                    </p>
                  </FaqItem>

                  <FaqItem question="How does Unyted back up the claim that learners will understand academic topics faster?">
                    <p>
                      Unyted embraces the philosophy of "if you can explain it,
                      you know it." We help accelerate that process by providing
                      the tools for multiple collaborative strategies and
                      discourse-based pedagogies. See research on{' '}
                      <a
                        target="_blank"
                        rel="noreferrer"
                        href="https://www.researchgate.net/publication/222704753_Active_learning_and_cooperative_learning_Understanding_the_difference_and_using_both_styles_effectively"
                      >
                        Active Learning
                      </a>
                      ,{' '}
                      <a
                        target="_blank"
                        rel="noreferrer"
                        href="https://ro.ecu.edu.au/cgi/viewcontent.cgi?article=2902&context=ajte"
                      >
                        Effective Cooperative Learning
                      </a>
                      ,{' '}
                      <a
                        rel="noreferrer"
                        href="https://www.sciencedirect.com/science/article/pii/S2452301116300062"
                      >
                        Problem-Based Learning
                      </a>
                      , digital{' '}
                      <a
                        target="_blank"
                        rel="noreferrer"
                        href="http://www.nea.org/tools/16963.htm"
                      >
                        Project-Based Learning
                      </a>
                      , and{' '}
                      <a
                        target="_blank"
                        href="https://www.ncbi.nlm.nih.gov/pmc/articles/PMC5839644/"
                        rel="noreferrer"
                      >
                        Interest-Based Learning
                      </a>
                      .
                    </p>
                  </FaqItem>

                  <FaqItem
                    question={
                      'How does the TEAM Method develop Social Emotional Skills (SEL) in learners?'
                    }
                  >
                    <p>
                      Whenever a team tries to solve a problem together,{' '}
                      <Link target="_blank" to="/sel-encyclopedia">
                        SEL skills
                      </Link>{' '}
                      are a necessary part of success. This gives Unyted
                      educators better opportunities to hone in on skill
                      development during the academic process. It also gives
                      learners real life opportunities to practices these key
                      skills.
                    </p>
                  </FaqItem>

                  <FaqItem question="Can this be used outside of learning academic subjects?">
                    <p>
                      That's part of our mission! When learners are consistently
                      put in these scenarios, sure, they get better academic and
                      SEL Power Skills development. But, the magic is that it
                      forms habits that transfer outside of the technology. An
                      experienced Unyted learner uses The TEAM Method&trade; as
                      an instinct in many future work and life scenarios!
                    </p>
                  </FaqItem>
                </FaqContainer>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default OnlinePlatform;
